/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'classnames';
import React, { FunctionComponent, SyntheticEvent, useState } from 'react';

import { CustomFieldKeyWithId, DependentFieldValue, FieldValue } from '@api/v4/assets/customFieldTypes';

import { customFieldQuery, valuesAsString } from './helpers/custom-field-strings';

interface CustomFieldRow {
  customFieldKey: CustomFieldKeyWithId;
  customFieldValues: FieldValue[];
  dependentFields?: DependentFieldValue[];
}

interface CustomFieldAccordionRowProps {
  customField: CustomFieldRow;
  closeModal: () => void;
}

export const CustomFieldAccordionRow: FunctionComponent<CustomFieldAccordionRowProps> =
  ({ customField, closeModal }) => {
    const { customFieldKey, customFieldValues, dependentFields } = customField;
    const [isOpen, setIsOpen] = useState(false);
    const rowClasses = classNames({
      's-custom-field': true,
      'hasDependents': dependentFields?.length,
      'isOpen': isOpen && dependentFields?.length,
    });

    const filterOnCustomFields = (e: SyntheticEvent, key: string, values: string[]): void => {
      e.preventDefault();
      e.stopPropagation();

      if (closeModal) {
        closeModal(); // method to close modal in org search context
      } else {
        BF.dialog.dismiss(); // method to close modal in all other contexts
      }

      const query = customFieldQuery(key, values);
      BF.fx.fillInAndFilterQuery(query);
    };

    const handleOnRowClick = (e: SyntheticEvent): void => {
      if (BFG.hasFeature('rollout_dependent_custom_fields')) {
        setIsOpen(!isOpen);
      } else if (!BFG.showPageLite) {
        // TODO: move this to a new button on the row
        filterOnCustomFields(e, customFieldKey.name, customFieldValues.map(({ value }) => value));
      }
    };

    return (
      <>
        <tr
          key={customFieldKey.id}
          className={`${rowClasses} cf-override-${BFG.currentUser.role}-${customFieldKey.name.replace(' ', '_')}`}
          onClick={handleOnRowClick}
        >
          <td className="toggle-caret">
            {dependentFields?.length ? (
              <span
                aria-hidden="true"
                className={`${isOpen ? 'bff-caret-down' : 'bff-caret-up'}`}
              />
            ) : null}
          </td>
          <td className="col-width-60 field-key">{customFieldKey.name}</td>
          <td className="col-width-60 field-value">{valuesAsString(customFieldValues)}</td>
        </tr>
        {isOpen &&
          dependentFields?.map(({ id, name, value }) => (
            <tr
              key={id}
              className={rowClasses}
            >
              <td className="toggle-caret" />
              <td className="col-width-60 dependent-field">
                {name}
              </td>
              <td className="col-width-60 dependent-field field-value">
                {value.map((val) => val.value)}
              </td>
            </tr>
          ))
        }
      </>
    );
  };
